import PropTypes from "prop-types";
import { formatMoney } from "../formUtils";

function rateLabel(option) {
	if (option.note) return option.note;
	return option.rate === null ? "Volume rate" : `${formatMoney(option.rate)} per website`;
}

/** Radio cards for the package; two options share a row, three get a three-column row. */
function PackageChoices({ options, value, onChange }) {
	return (
		<div
			className={options.length === 2 ? "choices two" : "choices"}
			role="radiogroup"
			aria-label="Pricing">
			{options.map((option) => (
				<label className="choice" key={option.id}>
					<input
						type="radio"
						name="rate"
						value={option.id}
						checked={value === option.id}
						onChange={() => onChange(option.id)}
					/>
					<span>
						<b>{option.label}</b>
						<small>{rateLabel(option)}</small>
					</span>
				</label>
			))}
		</div>
	);
}

PackageChoices.propTypes = {
	options: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			rate: PropTypes.number,
			note: PropTypes.string,
		}),
	).isRequired,
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
};

export default PackageChoices;
